import Modal from "~/components/ui/modal/Modal";
import { tryCatch } from "~/helpers/tryCatch";

import styles from "./ApproveAllConfirmationModal.module.scss";
import { AutoApprovalControl, AutoApprovalField } from "./AutoApprovalControl";

type ApproveAllConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isAllApproved: boolean;
  toggleApprove: () => Promise<void>;
  isApproveLoading: boolean;
  autoApprovalField: AutoApprovalField | undefined;
};

export const ApproveAllConfirmationModal = ({
  isOpen,
  onClose,
  isAllApproved,
  toggleApprove,
  isApproveLoading,
  autoApprovalField,
}: ApproveAllConfirmationModalProps) => {
  const action = async () => {
    const result = await tryCatch(toggleApprove());
    if (!result.error) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      isLoading={isApproveLoading}
      buttonLabel={isAllApproved ? "Unapprove All" : "Approve All"}
      closeModal={onClose}
      modalLabel={
        <h3 className={styles.modalTitle}>
          {isAllApproved ? "Unapprove All" : "Approve All"}
        </h3>
      }
      actionButtonColor={isAllApproved ? "danger" : "primary"}
      action={action}
    >
      <div className={styles.modalContent}>
        <p>
          {isAllApproved
            ? "You are about to remove approval from all items. Continue?"
            : "You are about to approve all unapproved items. Continue?"}
        </p>
        {autoApprovalField && <AutoApprovalControl field={autoApprovalField} />}
      </div>
    </Modal>
  );
};
